import styled from "styled-components";
import Fonts from "../../../themes/Fonts";
import { fadeIn } from "../../Common/CommonStyles";

export const AutocompleteContainer = styled.div.attrs(props => ({
  'data-testid': props.testid
}))`
  position: relative;
  width: ${({ width }) => width || "100%"};
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AutocompleteLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  font-family: ${Fonts.familyVerlag};
`;

export const AutocompleteInput = styled.input`
  padding: 8px 12px;
  font-size: ${({ fontSize }) => fontSize || "14px"};
  font-family: ${Fonts.familyVerlag};
  border-radius: ${({ borderRadius }) => borderRadius || "4px"};
  border: 1px solid ${({ error }) => (error ? "#ff4d4f" : "#d9d9d9")};
  outline: none;
  width: 100%;
  height: ${({ height }) => height || "36px"};
  background-color: ${({ disabled }) => (disabled ? "#f5f5f5" : "#fff")};
  color: ${({ disabled }) => (disabled ? "#999" : "#333")};
  transition: all 0.3s ease;

  &:focus {
    border-color: ${({ error }) => (error ? "#ff4d4f" : "#1890ff")};
    box-shadow: 0 0 0 2px
      ${({ error }) =>
        error ? "rgba(255, 77, 79, 0.2)" : "rgba(24, 144, 255, 0.2)"};
  }

  &:hover:not(:disabled) {
    border-color: ${({ error }) => (error ? "#ff4d4f" : "#40a9ff")};
  }

  &::placeholder {
    color: #bfbfbf;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: #f5f5f5;
    color: #999;
  }

  /* Responsive */
  @media (max-width: 768px) {
    font-size: 14px;
    height: 36px;
    padding: 8px 10px;
  }
`;

export const AutocompleteDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: ${({ maxHeight }) => maxHeight || "200px"};
  overflow-y: auto;
  overflow-x: auto;
  animation: ${fadeIn} 0.2s ease-in-out;

  /* Scrollbar personalizado */
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const AutocompleteItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  font-family: ${Fonts.familyVerlag};
  color: ${({ disabled }) => (disabled ? "#999" : "#333")};
  background-color: ${({ highlighted }) =>
    highlighted ? "#f5f5f5" : "transparent"};
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  min-width: max-content;

  &:hover:not([disabled]) {
    background-color: #f5f5f5;
  }

  &:last-child {
    border-bottom: none;
  }

  &[disabled] {
    cursor: not-allowed;
    background-color: #fafafa;
  }

  /* Responsive */
  @media (max-width: 768px) {
    padding: 10px 12px;
    font-size: 13px;
  }
`;

export const AutocompleteLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  color: #666;
  font-size: 14px;
  font-family: ${Fonts.familyVerlag};
`;

export const AutocompleteError = styled.div`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
  font-family: ${Fonts.familyVerlag};
  animation: ${fadeIn} 0.3s ease-in-out;
`;

export const AutocompleteContainerFocus = styled(AutocompleteContainer)`
  .autocomplete-input:focus {
    border-color: #1890ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`;

export const AutocompleteRounded = styled(AutocompleteContainer)`
  .autocomplete-input {
    border-radius: 20px;
  }

  .autocomplete-dropdown {
    border-radius: 20px;
  }
`;

export const AutocompleteBold = styled(AutocompleteContainer)`
  .autocomplete-input {
    border-width: 2px;
  }

  .autocomplete-input:focus {
    border-width: 2px;
  }
`;

export const AutocompleteCompact = styled(AutocompleteContainer)`
  .autocomplete-input {
    height: 32px;
    padding: 6px 10px;
    font-size: 14px;
  }

  .autocomplete-item {
    padding: 6px 10px;
    font-size: 13px;
  }
`;

export const AutocompleteLarge = styled(AutocompleteContainer)`
  .autocomplete-input {
    height: 48px;
    padding: 12px 16px;
    font-size: 18px;
  }

  .autocomplete-item {
    padding: 12px 16px;
    font-size: 16px;
  }
`;
